var slider = {
	$this: $( '.js-slider' ),
	$owl: $( '.owl-carousel' ),
	$arrows: {
		prev: $( '.slider-arrow--prev'),
		next: $( '.slider-arrow--next'),
	},
	items: $( '.js-slider' ).hasClass( 'slider--home') ? 6 : 3,
	callback: function( e ) {
		$('.slide').imageLoader();
	},
	addClasses: function ( e ) {
		var idx = e.item.index;
		$('.slider--cursus .owl-item.cloned .youtube-wrap .youtube').prop('id', '');
		$('.slider--cursus .owl-item.item--left').removeClass('item--left');
    $('.slider--cursus .owl-item.item--right').removeClass('item--right');
    $('.slider--cursus .owl-item').eq(idx).addClass('item--left');
    $('.slider--cursus .owl-item').eq(idx+2).addClass('item--right');
	},
	init: function() {
		if ( slider.$owl.length > 0 && $('.owl-carousel .slide').length >= slider.items ) {
			slider.$this.removeClass('no-carousel');

			slider.$owl.owlCarousel({
					loop: true,
					margin: 0,
					onInitialized: slider.callback,
					touchDrag: true,
        	//video:true,
					items: slider.items,
			});
			slider.$owl.on('click', '.owl-item', function(e) {
				var $target = $(e.target).parents('.owl-item');
				if ( !$target.next().hasClass('active') ) {
					slider.$owl.trigger('next.owl.carousel');
					video.youtube.close();
				} else if ( !$target.prev().hasClass('active') ) {
					slider.$owl.trigger('prev.owl.carousel');
					video.youtube.close();
				}
			});
			slider.$owl.find( '.owl-item' ).hover( function() {
				if ( $(this).hasClass( 'item--left' ) ) {
					slider.$arrows.prev.addClass( 'hover' );
				} else if( $(this).hasClass( 'item--right' ) ) {
					slider.$arrows.next.addClass( 'hover' );
				}
			}, function() {
				slider.$arrows.prev.removeClass( 'hover' );
				slider.$arrows.next.removeClass( 'hover' );
			} );
			slider.$this.on( 'click', '.slider-arrow', function( e ) {
				e.preventDefault();
				var $target = $(e.target);
				if ( $target.hasClass( 'slider-arrow--next' ) ) {
					slider.$owl.trigger('next.owl.carousel');
					video.youtube.close();
				} else {
					slider.$owl.trigger('prev.owl.carousel');
					video.youtube.close();
				}
			} );

		} else {
			slider.$this.addClass('no-carousel');
		}
	},
};

// On change:
slider.$owl.on('changed.owl.carousel', function( e ) {
	slider.addClasses( e );
});

slider.$owl.on('initialized.owl.carousel', function(e){
	slider.addClasses( e );
});
